/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { seoSettingsRetailerAccessControl } from '../access-control/seoSettingsAccess.configuration'

const SeoSettingsRobotsTxtPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SeoSettingsRobotsTxtPage" */
      '../pages/robots-txt/SeoSettingsRobotsTxtPage'
    )
)

const SeoSettingsScopeWrapper = lazy(() =>
  import('../components/SeoSettingsScopeWrapper').then(m => ({
    default: m.SeoSettingsScopeWrapper,
  }))
)
// @hygen:inject page-import

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
//
// The outer `seo-settings` route is partner + site scoped and warehouse-less (its URL
// carries `/sites/:storeConfigId` but no `/warehouses/:warehouse_id`; see routes.ts). Its <Route> puts
// `storeConfigId` into the router match, which the child route's scope wrapper reads via useParams.
// DashRoute renders a route's scope wrapper *above* that route's own <Route>, so the child must stay
// nested under this site-scoped parent for the STORE_CONFIG picker to resolve the site. Mirrors
// cart-assistant; registered in the domain's `partnerScoped` router bucket.
export const seoSettingsPartnerScopedRouter = (
  <DomainRoute route="seo-settings">
    <DashSwitch>
      <DomainRoute
        exact
        route="seo-settings-robots-txt"
        component={SeoSettingsRobotsTxtPage as ComponentType<any>}
        accessControl={seoSettingsRetailerAccessControl}
        scopePickerComponent={SeoSettingsScopeWrapper as ComponentType<any>}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
